// Google Maps paints with literal colours, not CSS variables — read a
// semantic token's current value off the document (call once per mount; a
// theme switch while mounted is not followed).

export const cssColor = (token: string): string =>
  getComputedStyle(document.documentElement).getPropertyValue(token).trim();
